import React, { useState } from 'react';
import { AiOutlineDashboard } from 'react-icons/ai';
import buyerDashboard from '../../../assets/Docs/buyerDashboard.png'
import Seller_Dashboard from '../../../assets/Docs/sellerDashboard.png'
import { FaAndroid, FaGlobe, FaShoppingCart, FaUserTie } from 'react-icons/fa';
import { TagComponent } from '../Tabs';
import Seller_Dashboard_app from '../../../assets/AppImages/seller_dashboard.png'
import buyer_dashboard_app from '../../../assets/AppImages/buyer_dashboard.png'
const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('web');
  const [activeTab1, setActiveTab1] = useState('web');

  const handleTabClick = (tabId, setActive) => {
    setActive(tabId);
  };

  const tabs = [
    { id: 'web', label: 'Web App View' },
    { id: 'mobile', label: 'Mobile App View', disabled: true },
  ];

  const renderTabs = (activeState, setActive) => (
    <div className="flex border-b gap-3 border-[#b9ece6]">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`px-4 py-2 font-medium text-sm transition-colors duration-200 rounded-t-md ${activeState === tab.id
            ? 'border-b-2 border-[#1a9588] bg-[#1a9588] text-white'
            : 'text-gray-500 bg-[#dbf4f1]'
            } `}
          onClick={() =>  handleTabClick(tab.id, setActive)}
       
        >
          {tab.label}
        </button>
      ))}
    </div>
  );

  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">

      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <AiOutlineDashboard className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">
          Dashboard
        </h1>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="green" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="green" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>



      <hr />

      <div className="flex flex-col md:flex-row gap-8 scroll-smooth">
        <div className="md:w-3/4 lg:w-3/4 w-full p-4 text-start">
          <div id="start-setup" className="scroll-mt-20">
            <p className="text-gray-600 mb-6">
              Informative Dashboard for both 'Seller' & 'Buyer' highlights Order & Account Details.</p>
            {renderTabs(activeTab, setActiveTab)}
            <div className="mt-4 p-4 border border-gray-200 rounded-lg">
              {activeTab === 'web' && (
                <img
                  src={Seller_Dashboard}
                  alt="Web App View of Seller Setup"
                  className="w-full h-auto"
                />
            
              )}
              {activeTab === 'mobile' && (
                    <img
  src={Seller_Dashboard_app}
  alt="Web App View of Seller Setup"
  className="w-full h-auto max-h-[70vh] sm:max-h-[80vh] md:max-h-[85vh] object-contain rounded-md"
/>

              )}
            </div>
          </div>
          <div className="bg-yellow-50 border border-yellow-100 text-yellow-600 px-4 py-3 rounded relative my-4" role="alert">
            <p>Seller Dashboard</p>
          </div>
          <hr className="my-6" />

          <div id="create-your-buyer-profile" className="scroll-mt-20">
            {renderTabs(activeTab1, setActiveTab1)}
            <div className="mt-4 p-4 border border-gray-200 rounded-lg">
              {activeTab1 === 'web' && (
                <img
                  src={buyerDashboard}
                  alt="Web App View of Seller Profile"
                  className="w-full h-auto"
                />
              )}
              {activeTab1 === 'mobile' && (
                                   <img
  src={buyer_dashboard_app}
  alt="Web App View of Seller Setup"
  className="w-full h-auto max-h-[70vh] sm:max-h-[80vh] md:max-h-[85vh] object-contain rounded-md"
/>
              )}
            </div>
          </div>
          <div className="bg-yellow-50 border border-yellow-100 text-yellow-600 px-4 py-3 rounded relative my-4" role="alert">
            <p>Buyer Dashboard</p>
          </div>
          <hr className="my-6" />
        </div>
      </div>
    </div>
  )
}

export default Dashboard;